module.exports = __webpack_public_path__ + "static/Azure-logo-2c4bd469a28e39b7d2d8f82b558980d5.png";